// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoCirCloseCircleFilledSvg from "@fishx/icons-svg/es/asn/PtoCirCloseCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PtoCirCloseCircleFilled = function PtoCirCloseCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoCirCloseCircleFilledSvg
  }));
};

PtoCirCloseCircleFilled.displayName = 'PtoCirCloseCircleFilled';
export default React.forwardRef(PtoCirCloseCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoCirCloseCircleFilled.js
// module id = 3883
// module chunks = 0